(() => {
  document.addEventListener('alpine:init', () => {
    MicroModal.init();
    // Linked Products variant switching
    Alpine.data('LinkedProducts', (type) => ({
      linkedProductsType: '',
      $section: null,
      $products: [],
      products: [],
      hasSpecs: false,
      init() {
        let am = this;
        am.linkedProductsType = type;

        document.addEventListener('init-LinkedProducts', (e) => {
          if (am.$section) return;

          am.$section = e.target;
          am.$products = [...am.$section.querySelectorAll('[data-linked-product]')];

          // init products on page load
          (async () => {
            let px_products = am.$products.map(($item) => {
              let handle = $item.dataset.linkedProduct;
              return fetch(`/products/${handle}.js`).then(res => res.json());
            });

            am.products = await Promise.all(px_products);
            am.UpdateLinkedProductUrls();
          })();
        });
        subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
          am.UpdateLinkedProductUrls(e.data.variant.options);
        });
      },

      UpdateLinkedProductUrls(current_values) {
        let am = this;

        if (!am.products.length) return;

        am.$products.forEach(($product) => {
          let handle = $product.dataset.linkedProduct;
          let product = am.products.find(p => p.handle == handle);

          if (!product) return;

          if (!current_values) {
            current_values = JSON.parse($product.dataset.current_values);
          }

          let optionIdsToMatch = [1, 2, 3];
          if (am.linkedProductsType) {
            // exclude option from matching
            optionIdsToMatch = optionIdsToMatch.filter((id) => product.options.map(opt => opt.name).indexOf(am.linkedProductsType) !== (id - 1));
            //console.log(optionIdsToMatch);
          }

          let valuesToMatch = optionIdsToMatch.map((id) => current_values[(id - 1)]);

          let matching_variant = product.variants.find((v) => {
            let v_options = optionIdsToMatch.map((id) => v[`option${id}`]).join('/');
            return v_options == valuesToMatch.join('/')
          });
          if (!matching_variant) return;
          $product.setAttribute('href', `/products/${handle}?variant=${matching_variant.id}`);

          // apply soldout class if not available
          const shapeLabel = $product.querySelector('label')
          if (shapeLabel) {
            shapeLabel.classList.toggle('disabled', !(matching_variant && matching_variant.available));
          }
        });
      }
    }));


    Alpine.data('CheckCompatibility', () => ({
      e_OpenCheckCompatibilityModal() {

        MicroModal.show('check-compatibility')

      }
    }))
    Alpine.data('LensFeatureChart', () => ({
      e_OpenLensFeatureChartModal() {

        MicroModal.show('lens-feature-chart')

      }
    }))
    Alpine.data('ColorQuiz', () => ({
      e_OpenColorQuizModal() {

        MicroModal.show('color-quiz-modal')

      }
    }))
    Alpine.data('LensColorGuide', () => ({
      e_LensColorGuide() {

        MicroModal.show('pop-lens-color-guide', {disableScroll: true})
        const width = window.innerWidth;
        const height = window.innerHeight;
        console.log('width:', width, ' height ', height)
        if (width > 749 && height < 900) {
          const pop_lens_color_guide = document.querySelector('#pop-lens-color-guide .pop-lens-color-guide');
          setTimeout(() => {
            console.log('about to scroll 2')
            pop_lens_color_guide.scrollIntoView();
          }, 10)
        }
      }
    }))
  })
})()